// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.live-search {
   background-color: #fff;
   box-sizing: border-box;
   box-shadow: 0 5px 12px 2px rgba(0,0,0,0.25);
   margin-top: 32px;
   max-height: 220px;
   overflow: auto;
   position: absolute;
   z-index: 5;
}

/* css for ie */
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
       .live-search {
           background-color: #fff;
           box-sizing: border-box;
           box-shadow: 0 5px 12px 2px rgba(0,0,0,0.25);
           margin-top: 0px;
           max-height: 220px;
           overflow: auto;
           position: absolute;
           z-index: 5;
        }
   }
/* ------------- */

.live-search ul {
   list-style: none;
   margin: 0;
   padding: 0;
}
.live-search a {
   cursor: pointer;
   padding: 6px 25px 6px 10px;
}
.live-search a:hover {
   background-color: #f4f5f7;
   text-decoration: none;
}
.live-search img {
   display: block;
   margin-right: 10px;
   border-radius: 50%;
   min-width: 32px;
   width: 32px;
   height: 32px;
}
.live-search .name, .live-search .desc {
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
}
.live-search .desc {
   color: #999;
   font-size: 12px;
}
.live-search .not-found {
   padding: 10px 20px;
}
.error {
   font-size: 13px;
   color: #d32f2f;
}
.mat-dialog-title {
   overflow-wrap: anywhere;
   max-width: 540px;
}
mat-dialog-content {
   overflow: hidden;
   width: 588px;
   max-height: 70vh;
}
.social {
   margin-top: 1em;
}
.social a {
   cursor: pointer;
   display: inline-block;
   margin-left: .5em;
   text-decoration: none;
   vertical-align: middle;
}
.social .mat-icon {
   color: #2ab4c0;
   font-size: 36px;
   width: 36px;
   height: 36px;
}
.social img {
   display: block;
   width: 24px;
   height: 24px;
}
.link {
   border: 1px solid #00b2c9;
   color: #444;
   padding: 0 .5em;
}
.copy {
   border-radius: 0;
   box-shadow: none;
   min-width: inherit;
   padding: 0 12px;
}
input, textarea {
   outline: none;
}
textarea {
   resize: none;
}
.select {
   margin-top: 2em;
}
.block {
   display: block;
}
.message {
   margin-top: 1em;
}
/* @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    .mat-dialog-container{
        overflow: visible;
    }
} */

/*::ng-deep .mat-form-field-infix {*/
   /*background-color: white;*/
   /*border-top: none;*/
/*}*/
/*::ng-deep .mat-form-field-infix, ::ng-deep .mat-form-field-label {*/
   /*padding-left: .5em;*/
   /*padding-right: .5em;*/
/*}*/
/*::ng-deep .mat-form-field-wrapper {*/
   /*padding-bottom: .5em;*/
/*}*/
/*::ng-deep .mat-form-field-underline {*/
   /*bottom: .5em;*/
/*}*/
/*input, ::ng-deep .mat-input-element {*/
   /*color: #555;*/
/*}*/
.private-share {
   display: block;
   margin-top: 1em;
}
.label {
   display: block;
   margin-bottom: 10px;
}
.send button {
   font-size: 13px;
   line-height: 24px;
   min-width: inherit;
   padding: 0 1em;
}
mat-select + mat-select {
   margin-left: 2em;
   width: 30%;
}
mat-checkbox + mat-form-field {
   margin-left: 1em;
}
mat-dialog-actions table {
   border-collapse: collapse;
   width: 100%;
}
mat-dialog-actions td:last-child {
   text-align: right;
}
.advanced {
   color: #ba68c8;
   cursor: pointer;
   float: right;
   font-size: 12px;
   margin-top: 10px;
   margin-right: 1em;
}
.social a.advanced:hover {
   text-decoration: underline;
}
mat-dialog-actions button + button {
   margin-left: 1em;
}
.peoples-wrapper {
   max-height: 150px;
   overflow-y: auto;
}
.peoples {
   width: 100%;
}
.peoples td {
   border-bottom: 1px solid #ebebeb;
   padding: 5px 5px;
}
.peoples td:nth-child(3) {
   width: 140px;
}
.peoples td:nth-child(4) {
   width: 32px;
}
.peoples td:first-child {
   width: 42px;
}
.peoples td:last-child {
   width: 32px;
}
.peoples img {
   border-radius: 50%;
   width: 32px;
   height: 32px;
   display: block;
}
.disabled-icon {
   color: #aaa;
   cursor: not-allowed;
   display: block;
}
.delete-icon {
   color: #aaa;
   cursor: pointer;
   display: block;
}
.delete-icon:hover {
   color: #f44336;
}
.close {
   color: #aaa;
   cursor: pointer;
   position: absolute;
   top: -16px;
   right: -16px;
}
.close:hover {
   color: #f44336;
}
.hint {
   color: #999;
   font-size: 11px;
}
.fill {
   width: 100%;
}
.desc {
   color: #999;
   font-size: 12px;
}
.search-people {
   border: none;
   border-bottom: 1px solid #ba68c8;
   padding: 0 6px;
}
.add-people {
   color: #00b2c9;
   margin-left: 1em;
   min-width: inherit;
}
.more-options {
   margin-top: 1em;
}
.flex mat-checkbox {
   font-size: 12px;
}
.share-icon {
   color: #aaa;
   cursor: pointer;
   display: block;
}
.flex-container {
   display: flex;
   align-items: center;
}
mat-select + mat-checkbox {
   margin-left: 1em;
}
@media screen and (max-width: 700px) {
   mat-dialog-content{
      width: auto;
   }
}
::ng-deep .mat-button:hover .mat-button-focus-overlay{
   opacity: 0.04 !important;
}
.forward-share {
   text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/app/dms/sharing/sharing.component.css"],"names":[],"mappings":"AAAA;GACG,sBAAsB;GACtB,sBAAsB;GACtB,2CAA2C;GAC3C,gBAAgB;GAChB,iBAAiB;GACjB,cAAc;GACd,kBAAkB;GAClB,UAAU;AACb;;AAEA,eAAe;AACf;OACO;WACI,sBAAsB;WACtB,sBAAsB;WACtB,2CAA2C;WAC3C,eAAe;WACf,iBAAiB;WACjB,cAAc;WACd,kBAAkB;WAClB,UAAU;QACb;GACL;AACH,kBAAkB;;AAElB;GACG,gBAAgB;GAChB,SAAS;GACT,UAAU;AACb;AACA;GACG,eAAe;GACf,0BAA0B;AAC7B;AACA;GACG,yBAAyB;GACzB,qBAAqB;AACxB;AACA;GACG,cAAc;GACd,kBAAkB;GAClB,kBAAkB;GAClB,eAAe;GACf,WAAW;GACX,YAAY;AACf;AACA;GACG,gBAAgB;GAChB,uBAAuB;GACvB,mBAAmB;AACtB;AACA;GACG,WAAW;GACX,eAAe;AAClB;AACA;GACG,kBAAkB;AACrB;AACA;GACG,eAAe;GACf,cAAc;AACjB;AACA;GACG,uBAAuB;GACvB,gBAAgB;AACnB;AACA;GACG,gBAAgB;GAChB,YAAY;GACZ,gBAAgB;AACnB;AACA;GACG,eAAe;AAClB;AACA;GACG,eAAe;GACf,qBAAqB;GACrB,iBAAiB;GACjB,qBAAqB;GACrB,sBAAsB;AACzB;AACA;GACG,cAAc;GACd,eAAe;GACf,WAAW;GACX,YAAY;AACf;AACA;GACG,cAAc;GACd,WAAW;GACX,YAAY;AACf;AACA;GACG,yBAAyB;GACzB,WAAW;GACX,eAAe;AAClB;AACA;GACG,gBAAgB;GAChB,gBAAgB;GAChB,kBAAkB;GAClB,eAAe;AAClB;AACA;GACG,aAAa;AAChB;AACA;GACG,YAAY;AACf;AACA;GACG,eAAe;AAClB;AACA;GACG,cAAc;AACjB;AACA;GACG,eAAe;AAClB;AACA;;;;GAIG;;AAEH,oCAAoC;GACjC,2BAA2B;GAC3B,oBAAoB;AACvB,IAAI;AACJ,qEAAqE;GAClE,sBAAsB;GACtB,uBAAuB;AAC1B,IAAI;AACJ,sCAAsC;GACnC,wBAAwB;AAC3B,IAAI;AACJ,wCAAwC;GACrC,gBAAgB;AACnB,IAAI;AACJ,wCAAwC;GACrC,eAAe;AAClB,IAAI;AACJ;GACG,cAAc;GACd,eAAe;AAClB;AACA;GACG,cAAc;GACd,mBAAmB;AACtB;AACA;GACG,eAAe;GACf,iBAAiB;GACjB,kBAAkB;GAClB,cAAc;AACjB;AACA;GACG,gBAAgB;GAChB,UAAU;AACb;AACA;GACG,gBAAgB;AACnB;AACA;GACG,yBAAyB;GACzB,WAAW;AACd;AACA;GACG,iBAAiB;AACpB;AACA;GACG,cAAc;GACd,eAAe;GACf,YAAY;GACZ,eAAe;GACf,gBAAgB;GAChB,iBAAiB;AACpB;AACA;GACG,0BAA0B;AAC7B;AACA;GACG,gBAAgB;AACnB;AACA;GACG,iBAAiB;GACjB,gBAAgB;AACnB;AACA;GACG,WAAW;AACd;AACA;GACG,gCAAgC;GAChC,gBAAgB;AACnB;AACA;GACG,YAAY;AACf;AACA;GACG,WAAW;AACd;AACA;GACG,WAAW;AACd;AACA;GACG,WAAW;AACd;AACA;GACG,kBAAkB;GAClB,WAAW;GACX,YAAY;GACZ,cAAc;AACjB;AACA;GACG,WAAW;GACX,mBAAmB;GACnB,cAAc;AACjB;AACA;GACG,WAAW;GACX,eAAe;GACf,cAAc;AACjB;AACA;GACG,cAAc;AACjB;AACA;GACG,WAAW;GACX,eAAe;GACf,kBAAkB;GAClB,UAAU;GACV,YAAY;AACf;AACA;GACG,cAAc;AACjB;AACA;GACG,WAAW;GACX,eAAe;AAClB;AACA;GACG,WAAW;AACd;AACA;GACG,WAAW;GACX,eAAe;AAClB;AACA;GACG,YAAY;GACZ,gCAAgC;GAChC,cAAc;AACjB;AACA;GACG,cAAc;GACd,gBAAgB;GAChB,kBAAkB;AACrB;AACA;GACG,eAAe;AAClB;AACA;GACG,eAAe;AAClB;AACA;GACG,WAAW;GACX,eAAe;GACf,cAAc;AACjB;AACA;GACG,aAAa;GACb,mBAAmB;AACtB;AACA;GACG,gBAAgB;AACnB;AACA;GACG;MACG,WAAW;GACd;AACH;AACA;GACG,wBAAwB;AAC3B;AACA;GACG,gBAAgB;AACnB","sourcesContent":[".live-search {\n   background-color: #fff;\n   box-sizing: border-box;\n   box-shadow: 0 5px 12px 2px rgba(0,0,0,0.25);\n   margin-top: 32px;\n   max-height: 220px;\n   overflow: auto;\n   position: absolute;\n   z-index: 5;\n}\n\n/* css for ie */\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n       .live-search {\n           background-color: #fff;\n           box-sizing: border-box;\n           box-shadow: 0 5px 12px 2px rgba(0,0,0,0.25);\n           margin-top: 0px;\n           max-height: 220px;\n           overflow: auto;\n           position: absolute;\n           z-index: 5;\n        }\n   }\n/* ------------- */\n\n.live-search ul {\n   list-style: none;\n   margin: 0;\n   padding: 0;\n}\n.live-search a {\n   cursor: pointer;\n   padding: 6px 25px 6px 10px;\n}\n.live-search a:hover {\n   background-color: #f4f5f7;\n   text-decoration: none;\n}\n.live-search img {\n   display: block;\n   margin-right: 10px;\n   border-radius: 50%;\n   min-width: 32px;\n   width: 32px;\n   height: 32px;\n}\n.live-search .name, .live-search .desc {\n   overflow: hidden;\n   text-overflow: ellipsis;\n   white-space: nowrap;\n}\n.live-search .desc {\n   color: #999;\n   font-size: 12px;\n}\n.live-search .not-found {\n   padding: 10px 20px;\n}\n.error {\n   font-size: 13px;\n   color: #d32f2f;\n}\n.mat-dialog-title {\n   overflow-wrap: anywhere;\n   max-width: 540px;\n}\nmat-dialog-content {\n   overflow: hidden;\n   width: 588px;\n   max-height: 70vh;\n}\n.social {\n   margin-top: 1em;\n}\n.social a {\n   cursor: pointer;\n   display: inline-block;\n   margin-left: .5em;\n   text-decoration: none;\n   vertical-align: middle;\n}\n.social .mat-icon {\n   color: #2ab4c0;\n   font-size: 36px;\n   width: 36px;\n   height: 36px;\n}\n.social img {\n   display: block;\n   width: 24px;\n   height: 24px;\n}\n.link {\n   border: 1px solid #00b2c9;\n   color: #444;\n   padding: 0 .5em;\n}\n.copy {\n   border-radius: 0;\n   box-shadow: none;\n   min-width: inherit;\n   padding: 0 12px;\n}\ninput, textarea {\n   outline: none;\n}\ntextarea {\n   resize: none;\n}\n.select {\n   margin-top: 2em;\n}\n.block {\n   display: block;\n}\n.message {\n   margin-top: 1em;\n}\n/* @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n    .mat-dialog-container{\n        overflow: visible;\n    }\n} */\n\n/*::ng-deep .mat-form-field-infix {*/\n   /*background-color: white;*/\n   /*border-top: none;*/\n/*}*/\n/*::ng-deep .mat-form-field-infix, ::ng-deep .mat-form-field-label {*/\n   /*padding-left: .5em;*/\n   /*padding-right: .5em;*/\n/*}*/\n/*::ng-deep .mat-form-field-wrapper {*/\n   /*padding-bottom: .5em;*/\n/*}*/\n/*::ng-deep .mat-form-field-underline {*/\n   /*bottom: .5em;*/\n/*}*/\n/*input, ::ng-deep .mat-input-element {*/\n   /*color: #555;*/\n/*}*/\n.private-share {\n   display: block;\n   margin-top: 1em;\n}\n.label {\n   display: block;\n   margin-bottom: 10px;\n}\n.send button {\n   font-size: 13px;\n   line-height: 24px;\n   min-width: inherit;\n   padding: 0 1em;\n}\nmat-select + mat-select {\n   margin-left: 2em;\n   width: 30%;\n}\nmat-checkbox + mat-form-field {\n   margin-left: 1em;\n}\nmat-dialog-actions table {\n   border-collapse: collapse;\n   width: 100%;\n}\nmat-dialog-actions td:last-child {\n   text-align: right;\n}\n.advanced {\n   color: #ba68c8;\n   cursor: pointer;\n   float: right;\n   font-size: 12px;\n   margin-top: 10px;\n   margin-right: 1em;\n}\n.social a.advanced:hover {\n   text-decoration: underline;\n}\nmat-dialog-actions button + button {\n   margin-left: 1em;\n}\n.peoples-wrapper {\n   max-height: 150px;\n   overflow-y: auto;\n}\n.peoples {\n   width: 100%;\n}\n.peoples td {\n   border-bottom: 1px solid #ebebeb;\n   padding: 5px 5px;\n}\n.peoples td:nth-child(3) {\n   width: 140px;\n}\n.peoples td:nth-child(4) {\n   width: 32px;\n}\n.peoples td:first-child {\n   width: 42px;\n}\n.peoples td:last-child {\n   width: 32px;\n}\n.peoples img {\n   border-radius: 50%;\n   width: 32px;\n   height: 32px;\n   display: block;\n}\n.disabled-icon {\n   color: #aaa;\n   cursor: not-allowed;\n   display: block;\n}\n.delete-icon {\n   color: #aaa;\n   cursor: pointer;\n   display: block;\n}\n.delete-icon:hover {\n   color: #f44336;\n}\n.close {\n   color: #aaa;\n   cursor: pointer;\n   position: absolute;\n   top: -16px;\n   right: -16px;\n}\n.close:hover {\n   color: #f44336;\n}\n.hint {\n   color: #999;\n   font-size: 11px;\n}\n.fill {\n   width: 100%;\n}\n.desc {\n   color: #999;\n   font-size: 12px;\n}\n.search-people {\n   border: none;\n   border-bottom: 1px solid #ba68c8;\n   padding: 0 6px;\n}\n.add-people {\n   color: #00b2c9;\n   margin-left: 1em;\n   min-width: inherit;\n}\n.more-options {\n   margin-top: 1em;\n}\n.flex mat-checkbox {\n   font-size: 12px;\n}\n.share-icon {\n   color: #aaa;\n   cursor: pointer;\n   display: block;\n}\n.flex-container {\n   display: flex;\n   align-items: center;\n}\nmat-select + mat-checkbox {\n   margin-left: 1em;\n}\n@media screen and (max-width: 700px) {\n   mat-dialog-content{\n      width: auto;\n   }\n}\n::ng-deep .mat-button:hover .mat-button-focus-overlay{\n   opacity: 0.04 !important;\n}\n.forward-share {\n   text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
